import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';
import { apiConfig } from '../../config';

export function terminateCommissionOp(commissioningId) {
  const auth = window.__APP_AUTH;
  let url = apiConfig.commissionServiceTerminateCommissionOp(commissioningId);
  const headers = {
    Accept: '*application/json*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'Content-Type': 'application/json'
  };

  let body = {
    reason: 'Wrong bundle'
  };

  return fetchdata(url, { headers: headers, method: 'DELETE', body: JSON.stringify(body) })
    .then((result) => {
      return result;
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
}
